import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Overview from './Overview';
import Accounts from './Accounts';
import Transactions from './Transactions';
import MobilePayments from './MobilePayments';
import Investments from './Investments';
import Insurances from './Insurances';
import Loans from './Loans';
import AdminPanel from './AdminPanel';
import ELBWallet from './ELBWallet';
import RecurringTransfers from './RecurringTransfers';
import VirtualCards from './VirtualCards';
import StaffManagement from './StaffManagement';
import MentionsLegales from './MentionsLegales';

function Dashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onMenuClick={toggleSidebar} />
        <main className="flex-1 overflow-y-auto p-4 md:p-8">
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard/overview" replace />} />
            <Route path="/overview" element={<Overview />} />
            <Route path="/accounts" element={<Accounts />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/recurring-transfers" element={<RecurringTransfers />} />
            <Route path="/mobile-payments" element={<MobilePayments />} />
            <Route path="/cards" element={<VirtualCards />} />
            <Route path="/investments" element={<Investments />} />
            <Route path="/insurances" element={<Insurances />} />
            <Route path="/loans" element={<Loans />} />
            <Route path="/elb-wallet" element={<ELBWallet />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/staff" element={<StaffManagement />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default Dashboard;
